export default __webpack_public_path__ + "static/media/icon2_trans.492c31d2.png";